import { contentTags } from "../constants/constants";

export function getPhrasesPerPage(story){
    let phrasesPerPage;
    if(story.tags && story.tags.some(t => [
        contentTags.PICTURE_STORY,
        contentTags.EARLY_READER_UP_AND_DOWN,
        contentTags.EARLY_READER_LETTER_FLIES,
        contentTags.EARLY_READER_CHANGE_ONE_PART,
        contentTags.EARLY_READER_ELKONIN_BOXES,
        contentTags.EARLY_READER_ELKONIN,
      ]
      .includes(t))){
        phrasesPerPage = 1;
    }

    return phrasesPerPage;
  }